import Vue from 'vue';
import VueRouter, { NavigationGuard } from 'vue-router';
import HomeScreen from '@/components/screens/HomeScreen.vue';
import ContentPageListScreen from '@/components/screens/ContentPageListScreen.vue';
import ContentPageFormScreen from '@/components/screens/ContentPageFormScreen.vue';
import LabelListScreen from '@/components/screens/LabelListScreen.vue';
import LabelFormScreen from '@/components/screens/LabelFormScreen.vue';
import DirectNavigationListScreen from '@/components/screens/DirectNavigationListScreen.vue';
import DirectNavigationFormScreen from '@/components/screens/DirectNavigationFormScreen.vue';
import NavigationItemListScreen from '@/components/screens/NavigationItemListScreen.vue';
import NavigationItemFormScreen from '@/components/screens/NavigationItemFormScreen.vue';
import WeeklySignListScreen from '@/components/screens/WeeklySignListScreen.vue';
import WeeklySignFormScreen from '@/components/screens/WeeklySignFormScreen.vue';
import OrderListScreen from '@/components/screens/OrderListScreen.vue';
import OrderFormScreen from '@/components/screens/OrderFormScreen.vue';
import ProductListScreen from '@/components/screens/ProductListScreen.vue';
import ProductFormScreen from '@/components/screens/ProductFormScreen.vue';
import ProductCategoryListScreen from '@/components/screens/ProductCategoryListScreen.vue';
import ProductCategoryFormScreen from '@/components/screens/ProductCategoryFormScreen.vue';
import LibraryItemListScreen from '@/components/screens/LibraryItemListScreen.vue';
import LibraryItemFormScreen from '@/components/screens/LibraryItemFormScreen.vue';
import ShopHeaderFormScreen from '@/components/screens/ShopHeaderFormScreen.vue';
import FooterFormScreen from '@/components/screens/FooterFormScreen.vue';
import EmployeeListScreen from '@/components/screens/EmployeeListScreen.vue';
import EmployeeFormScreen from '@/components/screens/EmployeeFormScreen.vue';
import CouponFormScreen from '@/components/screens/CouponFormScreen.vue';
import CouponListScreen from '@/components/screens/CouponListScreen.vue';
import FrontPageContentFormScreen from '@/components/screens/FrontPageContentFormScreen.vue';
import { globalState, userRepository } from '@/container';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'home',
        component: HomeScreen,
        meta: {
            navGroup: 'home',
            requiresAuth: true,
        },
    },
    {
        path: '/front-page-content',
        name: 'frontPageContentForm',
        component: FrontPageContentFormScreen,
        meta: {
            navGroup: 'front-page-content',
            requiresAuth: true,
        },
    },
    {
        path: '/label',
        name: 'labelList',
        component: LabelListScreen,
        meta: {
            navGroup: 'label',
            requiresAuth: true,
        },
    },
    {
        path: '/label/:id',
        name: 'labelForm',
        component: LabelFormScreen,
        meta: {
            navGroup: 'label',
            requiresAuth: true,
        },
    },
    {
        path: '/content-page',
        name: 'contentPageList',
        component: ContentPageListScreen,
        meta: {
            navGroup: 'content-page',
            requiresAuth: true,
        },
    },
    {
        path: '/content-page/:id',
        name: 'contentPageForm',
        component: ContentPageFormScreen,
        meta: {
            navGroup: 'content-page',
            requiresAuth: true,
        },
    },
    {
        path: '/direct-navigation',
        name: 'directNavigationList',
        component: DirectNavigationListScreen,
        meta: {
            navGroup: 'direct-navigation',
            requiresAuth: true,
        },
    },
    {
        path: '/direct-navigation/:id',
        name: 'directNavigationForm',
        component: DirectNavigationFormScreen,
        meta: {
            navGroup: 'direct-navigation',
            requiresAuth: true,
        },
    },
    {
        path: '/navigation-item/',
        name: 'navigationItemList',
        component: NavigationItemListScreen,
        meta: {
            navGroup: 'navigation-item',
            requiresAuth: true,
        },
    },
    {
        path: '/navigation-item/:id',
        name: 'navigationItemForm',
        component: NavigationItemFormScreen,
        meta: {
            navGroup: 'navigation-item',
            requiresAuth: true,
        },
    },
    {
        path: '/weekly-sign/',
        name: 'weeklySignList',
        component: WeeklySignListScreen,
        meta: {
            navGroup: 'weekly-sign',
            requiresAuth: true,
        },
    },
    {
        path: '/weekly-sign/:id',
        name: 'weeklySignForm',
        component: WeeklySignFormScreen,
        meta: {
            navGroup: 'weekly-sign',
            requiresAuth: true,
        },
    },
    {
        path: '/library-item/',
        name: 'libraryItemList',
        component: LibraryItemListScreen,
        meta: {
            navGroup: 'library-item',
            requiresAuth: true,
        },
    },
    {
        path: '/library-item/:id',
        name: 'libraryItemForm',
        component: LibraryItemFormScreen,
        meta: {
            navGroup: 'library-item',
            requiresAuth: true,
        },
    },
    {
        path: '/employee/',
        name: 'employeeList',
        component: EmployeeListScreen,
        meta: {
            navGroup: 'employee',
            requiresAuth: true,
        },
    },
    {
        path: '/employee/:id',
        name: 'employeeForm',
        component: EmployeeFormScreen,
        meta: {
            navGroup: 'employee',
            requiresAuth: true,
        },
    },
    {
        path: '/footer/',
        name: 'footerForm',
        component: FooterFormScreen,
        meta: {
            navGroup: 'footer',
            requiresAuth: true,
        },
    },
    {
        path: '/shop-header/',
        name: 'shopHeaderForm',
        component: ShopHeaderFormScreen,
        meta: {
            navGroup: 'shopHeader',
            requiresAuth: true,
        },
    },
    {
        path: '/order/',
        name: 'orderList',
        component: OrderListScreen,
        meta: {
            navGroup: 'order',
            requiresAuth: true,
        },
    },
    {
        path: '/order/:id',
        name: 'orderForm',
        component: OrderFormScreen,
        meta: {
            navGroup: 'order',
            requiresAuth: true,
        },
    },
    {
        path: '/product-category/',
        name: 'productCategoryList',
        component: ProductCategoryListScreen,
        meta: {
            navGroup: 'product-category',
            requiresAuth: true,
        },
    },
    {
        path: '/product-category/:id',
        name: 'productCategoryForm',
        component: ProductCategoryFormScreen,
        meta: {
            navGroup: 'product-category',
            requiresAuth: true,
        },
    },
    {
        path: '/product/',
        name: 'productList',
        component: ProductListScreen,
        meta: {
            navGroup: 'product',
            requiresAuth: true,
        },
    },
    {
        path: '/product/:id',
        name: 'productForm',
        component: ProductFormScreen,
        meta: {
            navGroup: 'product',
            requiresAuth: true,
        },
    },
    {
        path: '/coupon/',
        name: 'couponList',
        component: CouponListScreen,
        meta: {
            navGroup: 'coupon',
            requiresAuth: true,
        },
    },
    {
        path: '/coupon/:id',
        name: 'couponForm',
        component: CouponFormScreen,
        meta: {
            navGroup: 'coupon',
            requiresAuth: true,
        },
    },
];

let verifiedSessionAlive = false;

const authGuard: NavigationGuard = (to, from, next) => {
    if (!verifiedSessionAlive) {
        userRepository.getSelf().subscribe((result) => {
            if (result !== null && result !== '') {
                verifiedSessionAlive = true;
                next();
            } else {
                globalState.beginLogin();
            }
        });
    } else {
        next();
    }
};

const router = new VueRouter({
    mode: 'history',
    routes,
});

router.beforeEach(authGuard);

export default router;
